import { PopupMenu as PopupMenuUi } from 'shared/components/ui/popup-menu';
import styled, { css } from 'styled-components';

export const popupMenuMinHeight = 78;

export const PopupMenu = styled(PopupMenuUi)<{ $height?: number }>`
  width: 30.4rem;

  ${({ $height }) =>
    $height &&
    css`
      height: ${$height}px;
    `}
`;

export const IconContainer = styled.span<{ $color: string }>`
  color: ${({ $color }) => $color};
  line-height: 62.5%;
`;

export const SelectedIconContainer = styled.span`
  color: ${({ theme }) => theme.palette.primary.main};
  line-height: 62.5%;
`;
